import rg4js from 'raygun4js';
import store from '@/store';

declare const appProp: any;

const hostname = location.hostname;
const isProd = hostname.startsWith('edu-safetyr3') || hostname.startsWith('safetyr3');


if (isProd) {
  rg4js('apiKey', appProp.raygunApiKey);
  rg4js('enablePulse', true);
  rg4js('options', {
    captureMissingRequests: true,
  });
} else {
  rg4js('disableAutoBreadcrumbsConsole'); // 개발 환경일 때 console.log 가 레이건으로 래핑되는것 방지
}

export function trackerUserLogin() {
  if (isProd) {
    const userEmail = store.getters.userId;
    const userKey = store.getters.userKey;
    const userName = store.getters.userName;

    rg4js('setUser', {
      identifier: userKey,
      email: userEmail,
      fullName: userName,
      isAnonymous: false
    });
  }
}

export function trackerUserLogout() {
  if (isProd) {
    rg4js('setUser', {
      identifier: '',
      email: '',
      fullName: '',
    });
  }
}

export function trackEventRaygun(url: string) {
  if (isProd) {
    rg4js('trackEvent', {
      type: 'pageView',
      path: url
    });
  }
}

export function trackErrorEventRaygun(error: any) {
  if (isProd) {
    rg4js('send', {
      error
    });
  }
}
